export function getDeleteDialogData(count: number) {
  const title = count > 1 ? 'Delete Documents' : 'Delete Document';
  const docWordMsg = count > 1 ? 'documents' : 'document';
  return {
    title,
    description: '',
    size: 'md',
    type: 'MESSAGE',
    message: `${count} ${docWordMsg} selected. \n\nAre you sure you want to delete the selected ${docWordMsg}?\n This action cannot be undone.`,
    buttons: {
      cancelButtonText: 'Cancel',
      cancelColor: 'tertiary',
      deleteButtonText: 'Delete',
      primaryColor: 'primary-warn',
    },
  };
}
